import { render } from "./confirm-cancel-vip.vue?vue&type=template&id=aa032616&scoped=true&ts=true"
import script from "./confirm-cancel-vip.vue?vue&type=script&lang=ts"
export * from "./confirm-cancel-vip.vue?vue&type=script&lang=ts"

import "./confirm-cancel-vip.vue?vue&type=style&index=0&id=aa032616&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa032616"]])

export default __exports__